module.exports = __webpack_public_path__ + "media/assets/icons/mailWhite-8e4b9aebf490ca12c1a5f03af64a5502.svg";